import { API, graphqlOperation } from "aws-amplify";
import { configurePlusAppsync, configureGenericAppSync } from 'src/context/AuthContextUtility';



export const getBoardItems = async (boardPageType, ownerId, tabType, onSuccess, onFailure) => {

    await configurePlusAppsync()
    let qry = `query MyQuery {
        getBoardItemsRDS(board_page_type: "${boardPageType}", owner_id: "${ownerId}", tab_type: "${tabType}")
    }
      `
      executeQuery(qry, onSuccess, onFailure)

}

export const getAllBoardItemsByOwner = async (ownerId, onSuccess, onFailure) => {

    await configurePlusAppsync()
    let qry = `query MyQuery {
        getAllBoardItemsByOwnerRDS(owner_id: "${ownerId}")
    }
      `
      executeQuery(qry, onSuccess, onFailure)

}

export const updateBoardItem = async(input, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        updateBoardItem(input: {board_item_id: "${input.board_item_id}", board_item_title: "${input.board_item_title}", board_item_content: "${input.board_item_content}", last_updated_by: "${input.last_updated_by}"})
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}

export const addBoardItem = async(input, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        addBoardItem(input: {board_item_title: "${input.board_item_title}", board_item_content: "${input.board_item_content}", board_item_content_type: "${input.board_item_content_type}", owned_by: "${input.owner_id}", board_page_type: "${input.board_page_type}", created_by: "${input.created_by}", last_updated_by: "${input.last_updated_by}", is_default: ${input.is_default}, row_span:"${input.row_span}", column_span:"${input.column_span}", column_offset: "${input.column_offset}", row_order:"${input.row_order}", section:"${input.section}"})
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}

export const pushBoardItemToTeams = async(input, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        pushBoardItemToTeams(input: {board_item_title: "${input.board_item_title}", board_item_content: "${input.board_item_content}", board_item_content_type: "${input.board_item_content_type}", board_page_type: "${input.board_page_type}", created_by: "${input.created_by}", last_updated_by: "${input.last_updated_by}", is_default: ${input.is_default}, row_span:"${input.row_span}", column_span:"${input.column_span}", column_offset: "${input.column_offset}", row_order:"${input.row_order}", section:"${input.section}", board_item_announcement:"${input.board_item_announcement}"})
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}

export const deleteBoardItem = async(id, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        deleteBoardItem(board_item_id: "${id}")
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}


export const addOrUpdateBoardItemAnnouncement = async(input, onSuccess, onFailure) => {
    await configurePlusAppsync()
    const variables = {
        announcement: input.announcement,
      }
    let qry = `mutation MyMutation($announcement: String!) {
        addOrUpdateBoardItemAnnouncement(announcement: $announcement, id: "${input.id}", last_updated_by: "${input.last_updated_by}")
    }
    `
      executeQuery(qry, onSuccess, onFailure, variables)
}


export const getBoardItemByBoardItemId = async (boardItemId, onSuccess, onFailure) => {

    await configurePlusAppsync()
    let qry = `query MyQuery {
        getBoardItemByBoardItemId(board_item_id: "${boardItemId}")
    }
      `
      executeQuery(qry, onSuccess, onFailure)

}

export const getBrassIsLDAPOwnerOf = async (ldapGroup, stage, onSuccess, onFailure) => {
   await configurePlusAppsync()
   stage = (stage === 'dev' ? 'beta' : stage)
   let qry = `query MyQuery {
    getBrassIsLDAPOwnerOf(ldap_group: "${ldapGroup}", stage: "${stage}")
  }
    `
    executeQuery(qry, onSuccess, onFailure)
 }

export const getOwnersByUser = async (stage, onSuccess, onFailure) => {
   await configurePlusAppsync()
   stage = (stage === 'dev' ? 'beta' : stage)
   let qry = `query MyQuery {
    getOwnersByUser(stage: "${stage}")
  }
    `
    executeQuery(qry, onSuccess, onFailure)
 }

 export const getOwnersByOwnership = async (stage, onSuccess, onFailure) => {
   await configurePlusAppsync()
   stage = (stage === 'dev' ? 'beta' : stage)
   let qry = `query MyQuery {
    getOwnersByOwnership(stage: "${stage}")
  }
    `
    executeQuery(qry, onSuccess, onFailure)
 }

export const getOwnersForAdminUser = async (onSuccess, onFailure) => {
   await configurePlusAppsync()
   let qry = `query MyQuery {
    getOwnersForAdminUserRDS
  }
    `
    executeQuery(qry, onSuccess, onFailure)
 }

 export const getBooksWidgetContent = async (onSuccess, onFailure) => {
   await configurePlusAppsync()
   let qry = `query MyQuery {
    getBooksStatusRDS
  }
    `
    executeQuery(qry, onSuccess, onFailure)
 }

 export const updateLayout = async (input, onSuccess, onFailure) => {
    let inputString = ""
    input.forEach((item) => {
        inputString += `{board_item_id:"${item.board_item_id}", row_span:"${item.row_span}", column_span:"${item.column_span}", column_offset:"${item.column_offset}"}, `
    })
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        updateLayout(input: [${inputString}])
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}

export const deleteMultipleBoardItems = async (input, onSuccess, onFailure) => {
    let inputString = ""
    // let inputList = input.map((item)=>(item?.value))
    input.forEach((item, index) => {
        if(index === input?.length - 1){
            inputString += `"${item.value}"`
        } else {
            inputString += `"${item.value}",`
        }
    })
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        deleteMultipleBoardItems(input: [${inputString}])
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}

export const updateSections = async (input, onSuccess, onFailure) => {
    let inputString = ""
    input.forEach((item) => {
        inputString += `{board_item_id:"${item.board_item_id}", section:"${item.section}"}, `
    })
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        updateSections(input: [${inputString}])
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}


export const executeQuery = async(mQry, onSuccess, onFailure, variables= undefined) => {
    await configurePlusAppsync()
    API.graphql(graphqlOperation(mQry,variables)).then(result => {
        if (onSuccess) {
            configureGenericAppSync()
            onSuccess(result)
        }
    }, function (error) {
        if (onFailure) {
            configureGenericAppSync()
            onFailure(error)
        }
    });
    await configureGenericAppSync()
}


export const getOwnerCustomTabs = async (ownerId, excludeHidden, onSuccess, onFailure) => {

    await configurePlusAppsync()
    let qry = `query MyQuery {
        getOwnerCustomTabs(owner_id: "${ownerId}" exclude_hidden: ${excludeHidden})
    }
      `
      executeQuery(qry, onSuccess, onFailure)

}

// Deprecated, DO NOT USE 
export const hideOrUnhideCPTab = async(ownerId, tab, hide, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        hideOrUnhideCPTab(owner_id: "${ownerId}", tab: "${tab}", hide: ${hide})
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}

export const getOwnerTabPreferences = async (ownerId, preferenceType, onSuccess, onFailure) => {

    await configurePlusAppsync()
    let qry = `query MyQuery {
        getOwnerTabPreferences(owner_id: "${ownerId}" preference_type: "${preferenceType}")
    }
      `
      executeQuery(qry, onSuccess, onFailure)

}

export const getOwnerTabPreferencesWithOrder = async (ownerId, onSuccess, onFailure) => {

    await configurePlusAppsync()
    let qry = `query MyQuery {
        getOwnerTabPreferencesWithOrder(owner_id: "${ownerId}") {
            owner_id
            items {
                tab
                owner_id
                is_hidden
                tab_order_index
                preference_type
            }
        }
    }
      `
      executeQuery(qry, onSuccess, onFailure)

}

export const updateTabOrderPreferences = async (ownerId, tabOrderData, onSuccess, onFailure) => {
    await configurePlusAppsync()
    
    const tabOrderString = tabOrderData.map(item => 
        `{tab: "${item.tab}", order_index: "${item.order_index}"}`
    ).join(', ');
    
    let qry = `mutation MyMutation {
        updateTabOrderPreferences(input: {
            owner_id: "${ownerId}", 
            tab_order_data: [${tabOrderString}]
        })
    }
    `
    executeQuery(qry, onSuccess, onFailure)
}


export const createCustomTabOfOwner = async(tab, ownedBy, createdBy, tabType, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        createCustomTabOfOwner(owned_by: "${ownedBy}", tab: "${tab}", created_by: "${createdBy}", tab_type: "${tabType}" )
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}


export const updateCustomTabOfOwner = async(ownedBy, oldTabName, newTabName, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        updateCustomTabOfOwner(owned_by: "${ownedBy}", old_tab_name: "${oldTabName}", new_tab_name: "${newTabName}")
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}


export const deleteCustomTabOfOwner = async(ownedBy, tab, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `mutation MyMutation {
        deleteCustomTabOfOwner(owned_by: "${ownedBy}", tab: "${tab}")
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}

export const createClosePortalOwner = async(ownerName, ownerIdentifier, ownerType, createdBy, organizations, regions, vps, onSuccess, onFailure) => {
    await configurePlusAppsync()
    organizations =`[${organizations.map((org)=>(`"${org}"`))}]`
    regions = `[${regions.map((region)=>(`"${region}"`))}]`
    vps = `[${vps.map((vp)=>(`"${vp}"`))}]`
    let qry = `mutation MyMutation {
        createClosePortalOwner(owner_name: "${ownerName}", owner_identifier: "${ownerIdentifier}", owner_type: "${ownerType}", created_by: "${createdBy}", organizations: ${organizations}, regions: ${regions}, vps: ${vps})
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}

export const updateClosePortalOwner = async(ownerId, ownerName, ownerIdentifier, organizations, regions, vps, lastUpdatedBy, onSuccess, onFailure) => {
    await configurePlusAppsync()
    organizations =`[${organizations.map((org)=>(`"${org}"`))}]`
    regions = `[${regions.map((region)=>(`"${region}"`))}]`
    vps = `[${vps.map((vp)=>(`"${vp}"`))}]`
    let qry = `mutation MyMutation {
        updateCPOwnerInfo(input: {owner_id: "${ownerId}", owner_name: "${ownerName}", owner_identifier: "${ownerIdentifier}", organizations: ${organizations}, regions: ${regions}, vps: ${vps}, last_updated_by: "${lastUpdatedBy}"})
    }
    `
      executeQuery(qry, onSuccess, onFailure)
}

export const getOwnerDetails = async (ownerId, onSuccess, onFailure) => {
    await configurePlusAppsync()
    let qry = `query MyQuery {
        getOwnerDetailsRDS(owner_id: "${ownerId}")
    }
      `
      executeQuery(qry, onSuccess, onFailure)
}

export const sendFollowUpEmail = async (input) => {
    await configurePlusAppsync();
    const qry = `mutation SendFollowUpEmail($input: SendFollowUpEmailInput!) {
        sendFollowUpEmail(input: $input)
    }`;
    try {
        const result = await API.graphql(graphqlOperation(qry, { input }));
        return result;
    } finally {
        try {
            await configureGenericAppSync();
        } catch (configErr) {
            console.error('Failed to reconfigure AppSync', configErr);
        }
    }
};

export const cutTicketForFollowUpEmailFailure = async (input) => {
    await configurePlusAppsync();
    const qry = `mutation CutTicketForEmailFailure($input: CutTicketInput!) {
        cutTicketForEmailFailure(input: $input)
    }`;
    try {
        const result = await API.graphql(graphqlOperation(qry, { input }));
        return result;
    } catch (e) {
        console.error('Failed to cut ticket for email failure', e);
    } finally {
        try {
            await configureGenericAppSync();
        } catch (configErr) {
            console.error('Failed to reconfigure AppSync', configErr);
        }
    }
};
